import _taggedTemplateLiteral from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n        white-space: nowrap;\n        text-overflow: ellipsis;\n        overflow: hidden;\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { css } from 'styled-components';
export function ellipsis() {
  return function () {
    return css(_templateObject());
  };
}